//

import { SOURCE_FILTER_VALUES } from '@galleries/models/galleriesStateModel';
import { BazaarvoiceNetworkModerationStatus } from '@share/models/shareStateModel';

export const galleriesSourceFilterOptionToShareFilterOption = (
  galleryFilter: SOURCE_FILTER_VALUES | undefined,
): BazaarvoiceNetworkModerationStatus | undefined => {
  switch (galleryFilter) {
    case SOURCE_FILTER_VALUES.ALL_MEDIA:
      return undefined;
    case SOURCE_FILTER_VALUES.DISTRIBUTED:
      return BazaarvoiceNetworkModerationStatus.DISTRIBUTED;
    case SOURCE_FILTER_VALUES.RIGHTS_NEEDED:
      return BazaarvoiceNetworkModerationStatus.NEEDS_RIGHTS;
    case SOURCE_FILTER_VALUES.PRODUCTS_NEEDED:
      return BazaarvoiceNetworkModerationStatus.NEEDS_PRODUCTS;
    default:
      return undefined;
  }
};
